import type { CommercialProduct } from '@/api/catalog';
import type { ProductSubscription } from '@/api/products';
import type { TildeProduct } from '@/components/primitives/products';

export type CommercialProductCode =
  | 'Monotributo'
  | 'ResponsableInscripto'
  | 'EstudioContable'
  | 'ApiProgramadores'
  | 'Empresa';

export const COMMERCIAL_PRODUCT_LABEL: Record<CommercialProductCode, string> = {
  Monotributo: 'Monotributo',
  ResponsableInscripto: 'Responsable Inscripto',
  EstudioContable: 'Estudio Contable',
  ApiProgramadores: 'API para Programadores',
  Empresa: 'Producto por clasificar',
};

export function isCommercialProductCode(value: unknown): value is CommercialProductCode {
  return value === 'Monotributo'
    || value === 'ResponsableInscripto'
    || value === 'EstudioContable'
    || value === 'ApiProgramadores'
    || value === 'Empresa';
}

export function commercialProductFromTechnical(
  product: TildeProduct | ProductSubscription['product'],
  tier: string | undefined,
  explicitCommercialProduct?: CommercialProduct,
): CommercialProductCode {
  if (isCommercialProductCode(explicitCommercialProduct)) return explicitCommercialProduct;
  if (product === 'Estudio') return 'EstudioContable';
  if (product === 'Api') return 'ApiProgramadores';

  switch (tier?.toLowerCase()) {
    case undefined:
    case 'free':
    case 'mono':
      return 'Monotributo';
    case 'iva':
    case 'iva-pro':
      return 'ResponsableInscripto';
    default:
      return 'Empresa';
  }
}

export function commercialProductLabelFromTechnical(
  product: TildeProduct | ProductSubscription['product'],
  tier: string | undefined,
  explicitCommercialProduct?: CommercialProduct,
): string {
  return COMMERCIAL_PRODUCT_LABEL[
    commercialProductFromTechnical(product, tier, explicitCommercialProduct)
  ];
}
